import { PageLayout } from 'components/PageLayout';

export const Edit: React.FC = () => {
  return <PageLayout withBackButton title="Edit sale"></PageLayout>;
};
